export class IntegrationConstraints {
  public static IntegrationName = {
    MinLength: 1,
    MaxLength: 128,
  };

  public static Username = {
    MinLength: 2,
    MaxLength: 128,
  };

  public static Password = {
    MinLength: 12,
    MaxLength: 128,
  };
}
